import { Component, Inject, OnInit } from "@angular/core";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";

@Component({
  selector: "app-graph-modal",
  templateUrl: "./graph-modal.component.html",
  styleUrls: ["./graph-modal.component.scss"],
})
export class GraphModalComponent implements OnInit {

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    public dialogRef: MatDialogRef<GraphModalComponent>,
  ) { }

  graphColors = ["#0ede26", "#488f31", "#2031de", "#8f068a", "#de6d27", "#8f2246", "#895cde", "#8f5e15","#603232", "#FB5607"];

  ngOnInit(): void {
    this.data.floating = false;
  }

  closeModal(){
    this.dialogRef.close();
  }

}